export default "__VITE_ASSET__lN4OTv_7__"